
import { Menu as VMenu } from 'floating-vue'
import { defineComponent } from 'vue'

import { createPopperScrollGuard, PopperScrollGuard } from '~/utils/popper'

type ModalType = '' | 'intentional' | 'falsePositive'

export default defineComponent({
  name: 'AiReviewIssueIgnoreDropdown',
  components: {
    VMenu
  },
  emits: ['ignore', 'menuToggled'],
  props: {
    aiReviewIssueId: {
      type: String,
      required: true
    },
    forceClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDropdownOpen: false,
      activeModal: '' as ModalType,
      isModalOpen: false,
      dropdownScrollGuard: null as PopperScrollGuard | null
    }
  },
  created(): void {
    this.dropdownScrollGuard = createPopperScrollGuard(
      () => {
        this.isDropdownOpen = false
      },
      {
        useInitGuard: true
      }
    )
  },
  beforeDestroy(): void {
    this.dropdownScrollGuard?.cleanup()
  },
  watch: {
    forceClose(shouldClose: boolean): void {
      if (shouldClose && this.isDropdownOpen) {
        this.isDropdownOpen = false
      }
    }
  },
  methods: {
    openModal(modalType: ModalType): void {
      this.isDropdownOpen = false
      this.activeModal = modalType
      this.isModalOpen = true
    },
    closeModal(): void {
      this.isModalOpen = false
      this.activeModal = ''
    },
    handleIgnore(issueIds: string[]): void {
      this.closeModal()
      this.$emit('ignore', {
        ignoredIssueIds: issueIds
      })
    },
    onDropdownShow(): void {
      this.$emit('menuToggled', { id: this.aiReviewIssueId, isOpen: true })
      this.dropdownScrollGuard?.onShow()
    },
    onDropdownHide(): void {
      this.$emit('menuToggled', { id: this.aiReviewIssueId, isOpen: false })
      this.dropdownScrollGuard?.onHide()
    }
  }
})
